import "./ConnectionTimeout.css";
import React, { Fragment } from "react";
import logo from "../../assets/images/landbook.png";
import { Link } from "react-router-dom";
import { getAuth } from "firebase/auth";

const ConnectionTimeout = () => {
  const loggedInUser = getAuth().currentUser;
  return (
    <Fragment>
      <div className="error-body-container">
        <div className="connection-timeout-page">
          <div className="connection-timeout-page-land-book-logo">
            <img src={logo} alt="" />
          </div>

          <div className="connection-timeout-error">
            <h1 className="connection-timeout-error-title">
              Woops! <br />
              Connection Timeout :(
            </h1>
            <h2 className="connection-timeout-error-subtitle">
              Your session has expired!
            </h2>
            {loggedInUser ? (
              <Link to="/user/dashboard" className="goToButton">
                Go To Dashboard
              </Link>
            ) : (
              <Link to="/user/dashboard" className="goToButton">
                Go To Landing Page
              </Link>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ConnectionTimeout;
